export const isSameTask = (a, b) => a.taskId === b.taskId && a.activityId === b.activityId && a.studyId === b.studyId;
export const isSameActivity = (a, b) => a.activityId === b.activityId && a.studyId === b.studyId;
export const isSameTopic = (a, b) => {
    return a.topicId === b.topicId && a.studyId === b.studyId;
};
export const isSameCategory = (a, b) => {
    return a.categoryId === b.categoryId && a.studyId === b.studyId;
};
